// extracted by mini-css-extract-plugin
export default {"container":"q2-z"};